module.exports = __webpack_public_path__ + "banner_iphone17_mass_800x400.9bcef8db.png";